import Web3 from "web3";
import { MintingABINew } from "../ABIs/MintingABI_new";

const web3 = new Web3(process.env.REACT_APP_NODE_ADDRESS);


const MintingInstance = new web3.eth.Contract(MintingABINew, process.env.REACT_APP_CONTRACT_ADDRESS);
export { web3 }; 
export default MintingInstance;